import styles from './ccf-report-issue.module.scss';
import { useState } from 'react';
import {
    CcfBox,
  CcfCallOutboundIcon,
  CcfChatIcon,
  CcfInboundIcon,
  CcfOutboundIcon,
  CcfPhoneInboundIcon,
  CcfPhoneOutboundIcon,
  CcfTable,
  CcfTypography,
  RowDataStructure,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { Box, Button, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField, Typography, useTheme } from '@mui/material';
import TextArea from 'antd/es/input/TextArea';

/* eslint-disable-next-line */
export interface CcfReportIssueProps {}

/**
 * @example CcfAVNotifications()
 * @returns
 */
export function CcfReportIssue(props: CcfReportIssueProps) {
    const [category, setCategory] = useState("");
    const [priority, setPriority] = useState("");

    /**
     * Handles the change event for the category dropdown.
     * @param event - The change event from the category dropdown.
     */
    const handleChange = (event:any) => {
      setCategory(event.target.value);
    };

    /**
     * Handles the change event for the priority dropdown.
     * @param event - The change event from the priority dropdown.
     */
    const handlePriorityChange = (event: any) => {
      setPriority(event.target.value);
    };
 
  return (
   <div className={styles.reportIssueContainer}>
     <Typography variant='body1' className={styles.reportIssueTitle}>
      Report an Issue
    </Typography>
    <Typography className={styles.labelName}>Category <span className={styles.asterik_color}>*</span></Typography>
    <FormControl fullWidth variant="outlined" className={styles.margin_bottom} size="small">
    <Select
      labelId="category-select-label"
      id="category-select"
      value={category}
      onChange={handleChange}
      displayEmpty
    >
        <MenuItem value="" disabled>
          <em>Select</em>
        </MenuItem>
        <MenuItem value="unknown">Unknown</MenuItem>
        <MenuItem value="sound-dead-air">Sound - Dead Air</MenuItem>
        <MenuItem value="sound-delay">Sound - Delay</MenuItem>
        <MenuItem value="contact-disconnected-unexpectedly">Contact - Disconnected Unexpectedly</MenuItem>
        <MenuItem value="contact-refusing-unexpectedly">Contact - Refusing Unexpectedly</MenuItem>
        <MenuItem value="contact-abandon">Contact - Abandon</MenuItem>
        <MenuItem value="sound-broken">Sound - Broken</MenuItem>
        <MenuItem value="sound-echo">Sound - Echo</MenuItem>
        <MenuItem value="sound-static">Sound - Static</MenuItem>
        <MenuItem value="sound-one-way">Sound - One Way</MenuItem>
        <MenuItem value="myagent-myagent">myAgent - myAgent</MenuItem>
        <MenuItem value="agent-crash">Agent - Crash</MenuItem>
        <MenuItem value="myagent-failure-to-login">myAgent - Failure to Login</MenuItem>
        <MenuItem value="agent-incorrect-behavior">Agent - Incorrect Behavior</MenuItem>
        <MenuItem value="agent-reports">Agent - Reports</MenuItem>
        <MenuItem value="agent-display-issue">Agent - Display Issue</MenuItem>
      </Select>
    </FormControl>
    <Typography className={styles.labelName}>Priority <span className={styles.asterik_color}>*</span></Typography>
    <FormControl fullWidth variant="outlined" className={styles.margin_bottom} size="small">
    <Select
      labelId="category-select-label"
      id="category-select"
      value={priority}
      onChange={handlePriorityChange}
      displayEmpty
    >
        <MenuItem value="" disabled>
          <em>Select</em>
        </MenuItem>
        <MenuItem value="informarion">Information</MenuItem>
        <MenuItem value="average">Average</MenuItem>
        <MenuItem value="high">High</MenuItem>
        <MenuItem value="critical">Critical</MenuItem>
        </Select>
    </FormControl>
    <Typography className={styles.labelName}>Comment <span className={styles.asterik_color}>*</span></Typography>
    <TextArea rows={8} className={styles.margin_bottom}></TextArea>
   <CcfBox sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
   <FormControlLabel control={<Checkbox />} label="Include Event Log" />
   <Button variant="contained">Send</Button>
   </CcfBox>
   </div>
  );
}

export default CcfReportIssue;
